<template>
  <div>
    <div class="table-responsive theme-custom-table">
      <table class="table">
        <thead>
          <tr>
            <th>
              Nome
              <span class="pull-right">
                <button
                  @click.prevent="handleOrdering('name')"
                  :class="{ 'active': ordering === 'name' }"
                  type="button">
                  <i class="fa fa-chevron-up"></i>
                </button>
                <button
                  @click.prevent="handleOrdering('-name')"
                  :class="{ 'active': ordering === '-name' }"
                  type="button">
                  <i class="fa fa-chevron-down"></i>
                </button>
              </span>
            </th>
            <th>CNPJ</th>
            <th class="text-center">Telefone</th>
            <th>Limite Mensal</th>
            <th class="text-center">Viajantes</th>
            <th class="text-center">Pedidos</th>
            <th>
              Data de Criação
              <span class="pull-right">
                <button
                  @click.prevent="handleOrdering('creation_date')"
                  :class="{ 'active': ordering === 'creation_date' }"
                  type="button">
                  <i class="fa fa-chevron-up"></i>
                </button>
                <button
                  @click.prevent="handleOrdering('-creation_date')"
                  :class="{ 'active': ordering === '-creation_date' }"
                  type="button">
                  <i class="fa fa-chevron-down"></i>
                </button>
              </span>
            </th>
          </tr>
        </thead>

        <tbody>
          <company-item
            v-for="item in results"
            :key="`company-item-${item.id}`"
            :company="item" />
        </tbody>
      </table>
    </div>
    <!-- // TABLE -->

    <list-pagination
      :pages="pages"
      :current="page"
      @handlePagination="handlePagination" />
  </div>
</template>

<script>
import ListPagination from '@/components/ui/ListPagination'
import CompanyItem from '@/views/dashboard/company/list/CompanyItem'

export default {
  components: {
    ListPagination,
    CompanyItem
  },
  props: [
    'results',
    'pages',
    'page',
    'ordering',
    'search'
  ],
  methods: {
    handlePagination (page) {
      this.$emit('handleCompanies', {
        page,
        ordering: this.ordering,
        search: this.search
      })
    },
    handleOrdering (ordering) {
      this.$emit('handleCompanies', {
        page: this.page,
        ordering: ordering,
        search: this.search
      })
    }
  }
};
</script>
